<template>
    <footer class="footer">
        <div class="footer-contacts">
            <div class="contact-item">
                <a href="mailto:cm@taxibaku.az" class="contact-email">cm@taxibaku.az</a>&nbsp;<span>&lt;Corporate Management&gt;</span>
            </div>
            <div class="contact-item">
                <a href="tel:+994552530189">+994552530189</a>&nbsp;<span>Sahilə Ramazanova</span>
            </div>
        </div>

        <div class="footer-extra">
            <div class="language-selector">
                <select class="styled" v-model.trim="state.cfgUserLocale" @change="handleUserLocale">
                    <option value="en-EN">English (EN)</option>
                    <option value="ru-RU">Русский (RU)</option>
                    <option value="az-AZ">Azərbaycanca (AZ)</option>
                </select>
            </div>
            <div class="footer-credits">
                © 2025 <a href="https://www.189taxi.az/" class="website-link">189 TAXI</a>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { reactive } from "vue";

const state = reactive({
  cfgUserLocale: localStorage.getItem('cfgLocale') || "en-EN",
});

///////////////////////////////////////////////////////////////////////////////

const handleUserLocale = function () {
  localStorage.setItem('cfgLocale', state.cfgUserLocale || "");
  window.location.reload();
  window.scrollTo(0, 0);
}
</script>

<style lang="scss" scoped>
/* Footer Styles */
.footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: var(--theme-color-background-a20);
    border-top: 1px solid var(--theme-color-background-b10);
    padding: 16px 32px;
    margin-top: auto;
    font-size: 14px;
}

.footer-contacts {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.footer-extra {
    display: flex;
    flex-direction: column;
    text-align: right;
    gap: 16px;
}

.footer-credits {
    font-size: 14px;
}

.contact-item {
    display: flex;
    align-items: center;
}

.contact-email {
    font-weight: 600;
}

.contact-item a {
    color: var(--color-text);
    text-decoration: none;
    transition: opacity 0.2s ease;
}

.contact-item a:hover {
    opacity: 0.7;
    text-decoration: underline;
}

.website-link {
    font-weight: 600;
    color: var(--color-text);
}

.language-selector {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .footer {
        padding: 16px;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 16px;
    }

    .footer-content {
        gap: 16px;
    }

    .footer-contacts, .footer-extra {
        width: 100%;
        align-items: center;
        text-align: center;
    }
}

</style>